import Phaser from 'phaser';

import { getDialogueById } from '../../data/dialogues';

import { SCENE_KEYS } from '../../data/gameConstants';

import { getScoreRule } from '../../data/scoreRules';

import { Collectible } from '../../objects/Collectible';

import { InteractionZone } from '../../objects/InteractionZone';

import { AudioSystem } from '../../systems/AudioSystem';

import { SaveSystem } from '../../systems/SaveSystem';

import { ZoneCoreSystems } from '../../systems/ZoneCoreSystems';

import { ObjectiveHint } from '../../ui/ObjectiveHint';

import { SceneTransition } from '../../utils/SceneTransition';

import { Zone2AnimalEvents } from './Zone2AnimalEvents';

import { Zone2EarthquakeEvent } from './Zone2EarthquakeEvent';

import { ZONE2_POSITIONS, Zone2Map } from './Zone2Map';

import { ZONE3_POSITIONS } from '../zone3/Zone3Map';



const ANIMAL_SIGN_RADIUS = 105;



export class Zone2QuestFlow {

  private core: ZoneCoreSystems;

  private map: Zone2Map;

  private keris: Collectible;

  private hint: ObjectiveHint;

  private animals: Zone2AnimalEvents;

  private earthquake?: Zone2EarthquakeEvent;

  private animalTriggered = false;

  private animalDialoguesStarted = false;

  private animalDialoguesFinished = false;

  private earthquakeStarted = false;

  private transitioning = false;

  private lastKerisEnsure = 0;

  private exitX = ZONE2_POSITIONS.EXIT.x - 40;

  private animalZone?: InteractionZone;

  private kerisReadZone?: InteractionZone;

  private exitZone?: InteractionZone;



  constructor(

    core: ZoneCoreSystems,

    map: Zone2Map,

    keris: Collectible,

    hint: ObjectiveHint,

    animals: Zone2AnimalEvents,

  ) {

    this.core = core;

    this.map = map;

    this.keris = keris;

    this.hint = hint;

    this.animals = animals;

  }



  setInteractionZones(zones: {

    animal: InteractionZone;

    kerisRead: InteractionZone;

    exit: InteractionZone;

  }): void {

    this.animalZone = zones.animal;

    this.kerisReadZone = zones.kerisRead;

    this.exitZone = zones.exit;

    this.syncInteractionZones();

  }



  onKerisReadInteract(): void {

    if (this.core.quest.getStatus('zone2_read_keris1') === 'completed') return;

    if (!this.keris.isCollected()) return;

    this.startKerisRead();

  }



  onExitInteract(): void {

    if (this.transitioning) {
      const z3 = this.core.scene.game.scene.getScene(SCENE_KEYS.ZONE3);
      if (!z3?.scene.isActive() && this.core.scene.scene.isActive()) {
        this.transitioning = false;
        SceneTransition.reveal(this.core.scene);
        this.syncInteractionZones();
        this.transitionToZone3();
      }
      return;
    }

    if (this.core.quest.getStatus('zone2_survive_earthquake') !== 'completed') return;

    this.transitionToZone3();

  }



  start(): void {

    const enterDone = this.core.quest.getStatus('zone2_enter_forest') === 'completed';

    const watchDone = this.core.quest.getStatus('zone2_watch_animals') === 'completed';

    let findDone = this.core.quest.getStatus('zone2_find_keris1') === 'completed';

    const readDone = this.core.quest.getStatus('zone2_read_keris1') === 'completed';

    const surviveDone = this.core.quest.getStatus('zone2_survive_earthquake') === 'completed';

    this.animalDialoguesStarted = false;

    this.animalDialoguesFinished = false;

    this.keris.setUnlocked(false);



    if (this.keris.isCollected() && !findDone) {

      this.core.quest.completeQuest('zone2_find_keris1');

      findDone = true;

    }



    if (surviveDone) {

      this.openExit();

    }



    if (findDone || readDone) {

      this.keris.setUnlocked(false);

    } else if (watchDone) {

      this.unlockKeris();

      this.map.revealKerisBeacon();

    }



    if (watchDone) {

      this.map.setTenseAtmosphere(true);

      this.animalTriggered = true;

      this.animalDialoguesFinished = true;

    }



    if (!enterDone) {

      this.core.quest.activateQuest('zone2_enter_forest');

      this.applyStageUI('intro');

      this.core.showIntroDialogue('zone2_narrator', () => this.onEnterComplete());

      return;

    }



    if (!watchDone) {

      this.core.quest.activateQuest('zone2_watch_animals');

      this.applyStageUI('watch');

      this.refreshZoneQuestUI();

      this.showStageHint(

        'Amati Tanda Alam',

        ZONE2_POSITIONS.ANIMAL_TRIGGER.x,

        ZONE2_POSITIONS.ANIMAL_TRIGGER.y - 70,

      );

      return;

    }



    if (!findDone) {

      if (watchDone) {

        this.keris.setUnlocked(true);

      }

      this.core.quest.activateQuest('zone2_find_keris1');

      this.applyStageUI('keris');

      this.refreshZoneQuestUI();

      this.showStageHint(

        'Cari Keris 1',

        ZONE2_POSITIONS.KERIS.x,

        ZONE2_POSITIONS.KERIS.y - 70,

      );

      return;

    }



    if (!readDone) {
      this.core.quest.activateQuest('zone2_read_keris1');
      this.applyStageUI('read');
      this.refreshZoneQuestUI();
      if (!this.keris.isCollected()) {
        this.showStageHint('Ambil Keris 1', ZONE2_POSITIONS.KERIS.x, ZONE2_POSITIONS.KERIS.y - 70);
      }
      return;
    }



    if (!surviveDone) {

      this.core.quest.activateQuest('zone2_survive_earthquake');

      this.applyStageUI('earthquake');

      this.refreshZoneQuestUI();

      this.showStageHint('Siap Hadapi Gempa', 640, 180);

      this.startEarthquakeSequence();

      return;

    }



    this.core.quest.activateQuest('zone2_to_zone3');

    this.applyStageUI('exit');

    this.refreshZoneQuestUI();

    this.showStageHint(

      'Ke Rumah Bubungan',

      ZONE2_POSITIONS.EXIT.x - 60,

      ZONE2_POSITIONS.EXIT.y - 70,

    );

    this.syncInteractionZones();

  }



  onKerisCollected(): void {
    this.core.quest.completeQuest('zone2_find_keris1');
    this.core.quest.activateQuest('zone2_read_keris1');
    this.hint.hide();
    this.applyStageUI('read');
    this.refreshZoneQuestUI();
  }



  onAnimalSignInteract(): void {

    if (this.core.quest.getStatus('zone2_watch_animals') === 'completed') {

      if (

        !this.keris.canInteract()

        && this.core.quest.getStatus('zone2_find_keris1') !== 'completed'

      ) {

        this.unlockKeris();

      }

    }

    this.tryStartAnimalSequence(true);

  }



  update(delta: number, playerX: number, playerY: number): void {

    this.earthquake?.update(delta);

    this.tryStartAnimalSequence(false, playerX, playerY);

    this.ensureKerisAvailable();

    this.checkExit(playerX);

    this.checkExitBlocked(playerX);

  }



  private tryStartAnimalSequence(

    fromInteract: boolean,

    playerX?: number,

    playerY?: number,

  ): void {

    const status = this.core.quest.getStatus('zone2_watch_animals');



    if (status === 'completed') {

      if (fromInteract && this.core.quest.getStatus('zone2_find_keris1') !== 'completed') {

        this.showStageHint('Cari Keris 1', ZONE2_POSITIONS.KERIS.x, ZONE2_POSITIONS.KERIS.y - 70);

      }

      return;

    }



    if (status === 'locked') {

      this.core.quest.activateQuest('zone2_watch_animals');

    }

    if (this.core.quest.getStatus('zone2_watch_animals') !== 'active') return;

    if (this.core.dialogue.isActive()) return;



    if (this.animalTriggered && this.animals.hasPlayed() && !this.animals.isPlaying()) {
      if (!this.animalDialoguesFinished && !this.animalDialoguesStarted && !this.core.dialogue.isActive()) {
        this.playAnimalDialogues();
      }
      return;
    }



    if (this.animalTriggered) return;



    if (!fromInteract && playerX !== undefined && playerY !== undefined) {

      const dist = Phaser.Math.Distance.Between(

        playerX,

        playerY,

        ZONE2_POSITIONS.ANIMAL_TRIGGER.x,

        ZONE2_POSITIONS.ANIMAL_TRIGGER.y,

      );

      if (dist > ANIMAL_SIGN_RADIUS) return;

    } else if (!fromInteract) {

      return;

    }



    this.triggerAnimalEvent();

  }



  private onEnterComplete(): void {

    this.core.quest.completeQuest('zone2_enter_forest');

    this.core.quest.activateQuest('zone2_watch_animals');

    this.applyStageUI('watch');

    this.refreshZoneQuestUI();

    this.showStageHint(

      'Amati Tanda Alam',

      ZONE2_POSITIONS.ANIMAL_TRIGGER.x,

      ZONE2_POSITIONS.ANIMAL_TRIGGER.y - 70,

    );

  }



  private completeWatchStage(): void {

    if (this.core.quest.getStatus('zone2_watch_animals') === 'completed') {

      if (!this.keris.isCollected() && !this.keris.canInteract()) {

        this.unlockKeris();

      }

      this.syncInteractionZones();

      return;

    }

    this.core.quest.completeQuest('zone2_watch_animals');

    this.animalDialoguesStarted = false;

    this.animalDialoguesFinished = true;

    this.unlockKeris();

    this.syncInteractionZones();

  }



  private unlockKeris(): void {

    this.keris.setUnlocked(true);

    this.map.revealKerisBeacon();

    this.core.quest.activateQuest('zone2_find_keris1');

    this.applyStageUI('keris');

    this.refreshZoneQuestUI();

    this.showStageHint(

      'Cari Keris 1',

      ZONE2_POSITIONS.KERIS.x,

      ZONE2_POSITIONS.KERIS.y - 70,

    );

  }



  private startKerisRead(): void {

    if (this.core.quest.getStatus('zone2_read_keris1') === 'completed') return;

    this.core.quest.activateQuest('zone2_read_keris1');

    this.applyStageUI('read');

    this.refreshZoneQuestUI();

    this.showStageHint(

      'Baca Keris 1',

      ZONE2_POSITIONS.KERIS.x,

      ZONE2_POSITIONS.KERIS.y - 70,

    );



    const kerisDialogue = getDialogueById('zone2_keris1');

    const localDialogue = getDialogueById('zone2_keris1_local');



    const showLocal = () => {

      if (localDialogue) {

        this.core.dialogue.show(localDialogue, () => this.onKerisReadComplete());

      } else {

        this.onKerisReadComplete();

      }

    };



    if (kerisDialogue) {

      this.core.dialogue.show(kerisDialogue, showLocal);

    } else {

      showLocal();

    }

  }



  private onKerisReadComplete(): void {

    this.core.quest.completeQuest('zone2_read_keris1');

    this.applyStageUI('earthquake');

    this.refreshZoneQuestUI();

    this.startEarthquakeSequence();

  }



  private startEarthquakeSequence(): void {

    if (this.earthquakeStarted) return;

    this.earthquakeStarted = true;

    this.hint.hide();



    const boom = getDialogueById('zone2_earthquake_boom');

    const mission = getDialogueById('zone2_earthquake_mission');



    const runEvent = () => {

      this.core.quest.activateQuest('zone2_survive_earthquake');

      this.applyStageUI('earthquake');

      this.refreshZoneQuestUI();

      this.showStageHint(

        'Hindari Pohon dan Retakan',

        640,

        180,

      );

      const player = this.core.getPlayer();

      this.earthquake = new Zone2EarthquakeEvent(

        this.core.scene,

        player,

        this.core.score,

        30000,

        () => this.onHazardHit(),

      );

      this.earthquake.start((noHits) => this.onEarthquakeComplete(noHits));

    };



    const showMission = () => {

      if (mission) {

        this.core.dialogue.show(mission, runEvent);

      } else {

        runEvent();

      }

    };



    const showBoom = () => {

      this.core.scene.cameras.main.shake(500, 0.012);

      if (boom) {

        this.core.dialogue.show(boom, showMission);

      } else {

        showMission();

      }

    };



    showBoom();
  }



  private onEarthquakeComplete(noHits: boolean): void {

    this.core.quest.completeQuest('zone2_survive_earthquake');

    this.refreshZoneQuestUI();

    SaveSystem.save({ earthquakeNoHit: noHits });

    if (noHits) {

      const rule = getScoreRule('zone2_dodge');

      if (rule) this.core.score.addScore(rule.points, rule.label);

    }



    this.openExit();

  }



  private openExit(): void {

    this.map.openExitPath();

    this.core.removeObstacleNear(ZONE2_POSITIONS.EXIT_BLOCK.x, ZONE2_POSITIONS.EXIT_BLOCK.y);

    this.core.quest.activateQuest('zone2_to_zone3');

    this.applyStageUI('exit');

    this.refreshZoneQuestUI();

    this.showStageHint(

      'Ke Rumah Bubungan',

      ZONE2_POSITIONS.EXIT.x - 60,

      ZONE2_POSITIONS.EXIT.y - 70,

    );



    SaveSystem.save({

      rafflesiaPoints: this.core.score.getScore(),

    });

  }



  private checkExit(playerX: number): void {

    if (this.transitioning) return;

    if (this.core.quest.getStatus('zone2_survive_earthquake') !== 'completed') return;

    if (playerX >= this.exitX) {

      this.transitionToZone3();

    }

  }



  private checkExitBlocked(_playerX: number): void {
    // Blokir fisik saja — konsep tidak menyebut dialog peringatan di sini
  }



  onHazardHit(): void {
    // Feedback visual saja — konsep tidak menyebut dialog saat terkena hazard
  }



  private transitionToZone3(): void {

    if (this.transitioning) return;

    this.transitioning = true;

    this.core.quest.completeQuest('zone2_to_zone3');



    this.core.quest.activateQuest('zone3_arrive');



    SaveSystem.save({

      currentScene: SCENE_KEYS.ZONE3,

      currentZone: 3,

      rafflesiaPoints: this.core.score.getScore(),

      playerX: ZONE3_POSITIONS.SPAWN.x,

      playerY: ZONE3_POSITIONS.SPAWN.y,

    });



    this.hint.hide();

    AudioSystem.stopEarthquakeRumble();

    this.earthquake?.destroy();

    this.earthquake = undefined;

    this.core.scene.cameras.main.resetFX();

    SceneTransition.startNextFrame(this.core.scene, SCENE_KEYS.ZONE3);

    const fromScene = this.core.scene;
    const game = fromScene.game;
    window.setTimeout(() => {
      const z3 = game.scene.getScene(SCENE_KEYS.ZONE3);
      if (z3?.scene.isActive()) return;
      if (!fromScene.scene.isActive()) return;
      this.transitioning = false;
      this.syncInteractionZones();
      SceneTransition.reveal(fromScene);
    }, 1000);

  }



  destroy(): void {

    this.earthquake?.destroy();

    this.hint.destroy();

  }



  private showStageHint(text: string, x: number, y: number): void {

    this.hint.show(text, x, y);

  }



  private refreshZoneQuestUI(): void {

    this.core.refreshQuestPanel(2);

    this.syncInteractionZones();

  }



  private syncInteractionZones(): void {

    const watch = this.core.quest.getStatus('zone2_watch_animals');

    const find = this.core.quest.getStatus('zone2_find_keris1');

    const read = this.core.quest.getStatus('zone2_read_keris1');

    const survive = this.core.quest.getStatus('zone2_survive_earthquake');



    this.animalZone?.setEnabled(watch !== 'completed');



    const readPending = read !== 'completed'
      && (read === 'active' || find === 'completed');
    this.kerisReadZone?.setEnabled(readPending && this.keris.isCollected());

    if (watch === 'completed' && find !== 'completed' && !this.keris.isCollected()) {
      this.keris.setUnlocked(true);
    }

    this.exitZone?.setEnabled(survive === 'completed');

  }



  private applyStageUI(_stage: string): void {

    this.syncInteractionZones();

  }



  private triggerAnimalEvent(): void {

    this.animalTriggered = true;

    this.hint.hide();

    this.map.setTenseAtmosphere(true);

    const player = this.core.getPlayer();

    player.setMovementEnabled(false);

    this.core.setMobileControlsVisible(false);

    this.animals.play(() => {
      if (!this.animalDialoguesFinished && !this.animalDialoguesStarted && !this.core.dialogue.isActive()) {
        this.playAnimalDialogues();
      }
    });

    this.core.scene.time.delayedCall(720, () => {
      if (!this.animalDialoguesFinished && !this.animalDialoguesStarted && !this.core.dialogue.isActive()) {
        this.playAnimalDialogues();
      }
    });
  }



  private ensureKerisAvailable(): void {

    if (this.core.quest.getStatus('zone2_watch_animals') !== 'completed') return;

    if (this.core.quest.getStatus('zone2_find_keris1') === 'completed') return;

    if (this.keris.isCollected() || this.keris.canInteract()) return;

    const now = this.core.scene.time.now;

    if (now - this.lastKerisEnsure < 1500) return;

    this.lastKerisEnsure = now;

    this.unlockKeris();

  }



  private playAnimalDialogues(): void {
    if (this.animalDialoguesFinished) return;

    const watchStatus = this.core.quest.getStatus('zone2_watch_animals');
    if (watchStatus !== 'active' && watchStatus !== 'completed') return;

    if (this.core.dialogue.isActive()) return;

    if (this.animalDialoguesStarted) return;

    this.animalDialoguesStarted = true;
    this.core.getPlayer().setMovementEnabled(false);
    this.core.setMobileControlsVisible(false);

    const bujang = getDialogueById('zone2_bujang');
    const explanation = getDialogueById('zone2_narrator_animals');

    const finish = () => {
      this.animalDialoguesStarted = false;
      this.animalDialoguesFinished = true;
      if (this.core.quest.getStatus('zone2_watch_animals') !== 'completed') {
        this.completeWatchStage();
      }
      this.core.getPlayer().setMovementEnabled(true);
      this.core.setMobileControlsVisible(true);
    };

    const showExplanation = () => {

      if (explanation) {

        this.core.dialogue.show(explanation, finish);

      } else {

        finish();

      }

    };



    if (bujang) {

      this.core.dialogue.show(bujang, showExplanation);

    } else {

      showExplanation();

    }

  }

}


